<script>
    import { Pie } from 'vue-chartjs'
    import createChart from './mixins/createChart'
    import { ceil, cloneDeep } from "lodash"

    export default {
        extends: Pie,

        mixins: [createChart],

        props: {
            chartData: {
                type: Object,
                required: true,
                default: () => {}
            },

            scheme: {
                type: String,
                default: 'dark'
            },
        },

        data() {
            return {
                gradient: null,
                originalDataset: this.chartData.datasets.filter(dataset => !dataset.target)[0],
                targetDataset: this.chartData.datasets.filter(dataset => dataset.target)[0],

                options: {
                    aspectRatio: 3,

                    circumference: Math.PI,

                    cutoutPercentage: 50,

                    legend: {
                        display: false
                    },

                    legendCallback: chart => {
                        let text = []
                        let value = chart.data.datasets.length > 0 ? chart.data.datasets[0].data[0] : 0

                        text.push(`<div class="${chart.id}-legend block w-full text-center">`)
                        text.push(`${value.toLocaleString("en-GB",{maximumFractionDigits:2})}%`)
                        text.push('</div>')

                        if (this.hasTargets) {
                            text.push(`<div class="block w-full text-center">`)

                            if (!chart.data.isInverted) {
                                if ( value >= this.targetDataset.data[0] ) {
                                    text.push(`Target ${this.targetDataset.data[0]}% <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block ml-2 mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(-33.25 12.879) rotate(-90)" fill="#53ff4d"/></svg>`)
                                } else {
                                    text.push(`Target ${this.targetDataset.data[0]}% <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block ml-2 mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(43.25) rotate(90)" fill="#ff5d67"/></svg>`)
                                }
                            }

                            if (chart.data.isInverted) {
                                if ( value >= this.targetDataset.data[0] ) {
                                    text.push(`Target ${this.targetDataset.data[0]}% <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block ml-2 mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(-33.25 12.879) rotate(-90)" fill="#ff5d67"/></svg>`)
                                } else {
                                    text.push(`Target ${this.targetDataset.data[0]}% <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block ml-2 mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(43.25) rotate(90)" fill="#53ff4d"/></svg>`)
                                }
                            }

                            text.push('</div>')
                        }
                        return text.join('')
                    },

                    rotation: -1.0 * Math.PI,

                    tooltips: {
                        enabled: false
                    }
                }
            }
        },

        computed: {
            hasTargets() {
                return this.targetDataset ? true : false
            },
        },

        mounted () {
            this.buildGaugeChartData()
            this.createChart()
            this.createGaugeGradient()
            this.createGaugeLegend()

            this.$on('chart:destroy', () => {
                this.buildGaugeChartData()
            })

            this.$on('chart:render', () => {
                this.createGaugeLegend()
            })
        },

        methods: {
            buildGaugeChartData() {
                let thisMonth = this.originalDataset.data.length - 1

                // if (this.chartData.datasets.length < 1) {
                //     return
                // }

                let data = this.originalDataset.data[thisMonth]
                let label = this.originalDataset.label
                let remaining = 0

                if (data < 1) {
                    data = data * 100
                }

                remaining = ceil(100 - data, 2)

                // prevent data being built multiple times
                if (this.originalDataset.data.includes(remaining)) {
                    return
                }

                // this.chartData.datasets[0].data = [data, remaining]
                this.chartData.datasets = [
                    {data: [data, remaining]}
                ]
                this.chartData.labels = [label, '']
            },

            createGaugeGradient() {
                this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(42, 0, 217, 0)

                this.gradient.addColorStop(0.000, 'rgba(255, 233, 126, 1.000)');
                this.gradient.addColorStop(1.000, 'rgba(248, 0, 137, 1.000)');

                this.dataStyling = {
                    backgroundColor: [
                        this.gradient,
                        '#494A55'
                    ],
                    borderWidth: 0
                }
            },

            createGaugeLegend(){
                this.htmlLegend = this.generateLegend()

                let customLegend = $(this.$refs.canvas).parent().find('.customLegend')

                if (customLegend.length === 0) {
                    $(this.$refs.canvas).after('<div class="relative w-full customLegend mt-10"></div>')

                    customLegend = $(this.$refs.canvas).parent().find('.customLegend')
                }

                customLegend.html(this.htmlLegend)
            },
        }

    }
</script>